import React from "react";

import imgLogoRVPoint from "../../Assets/logo-rv-point.svg";
import imgLogoRVDigital from "../../Assets/logo-rv-digital.svg";
import imgLogoRVLogin from "../../Assets/logo-rv-login.svg";
interface LogoProps {
  type?: "RVPoint" | "RVDigital" | "RVLogin";
}

export const Logo: React.FC<LogoProps> = ({ type = "RVPoint" }) => {
  const logos = {
    RVPoint: imgLogoRVPoint,
    RVDigital: imgLogoRVDigital,
    RVLogin: imgLogoRVLogin
  };

  return (
    <img
      src={logos[type]}
      alt="Logo RV Point"
      height={type === "RVPoint" ? "40px" : "52px"}
    />
  );
};
